export default __webpack_public_path__ + "static/media/winter.c559bb9d.png";